export default[
    {
        image:"Images/Work1.jpg",
        Title:"CAn't Open This BEcause"
    },
    {
        image:"Images/Work2.jpg",
        Title:"CAn't Open This BEcause"
    },
    {
        image:"Images/Work1.jpg",
        Title:"CAn't Open This BEcause"
    },
    {
        image:"Images/Work1.jpg",
        Title:"CAn't Open This BEcause"
    },
    {
        image:"Images/Work2.jpg",
        Title:"CAn't Open This BEcause"
    },
    {
        image:"Images/Work1.jpg",
        Title:"CAn't Open This BEcause"
    },
]